// tooltip
function tooltip() {
    $('.triTooltipButton').click(function(){
        $(this).siblings('.triTooltipContent').fadeToggle('fast');
        if ($(this).attr('aria-expanded') == 'true') {
            $(this).attr('aria-expanded', false);
        } else {
            $(this).attr('aria-expanded', true)
        }
    })
    // Close if hit esc key
    $('.triTooltipButton').on('keydown', function(event) {
       if (event.key == "Escape") {
           $(this).siblings('.triTooltipContent').fadeOut('fast');
           $(this).attr('aria-expanded', false);
       }
    });
    // Close if click something else
    $('.triTooltipButton').focusout(function() {
       $(this).siblings('.triTooltipContent').fadeOut('fast');
       $(this).attr('aria-expanded', false);
    });
}

$( document ).ready(function() {
    tooltip();
});


// WEBPACK FOOTER //
// ./packages/OSB/js/modules/tooltip.js